@if (summaryItems() && (model$() | async); as model) {
  <div class="summary-top d-flex flex-wrap flex-no-gap border border-info rounded">
    @for (item of summaryItems()(model); track item.label) {
      <div class="d-flex px-2 {{ item.textRight ? 'w-100 justify-content-between' : '' }} {{ item.cssClass }}">
        <div class="text-lg-nowrap">{{ item.label }}</div>
        <div class="text-lg-nowrap">
          <strong>{{ item.value }}</strong>
        </div>
      </div>
    }
  </div>
}
